import { Grid } from '@material-ui/core'
import React, { FC } from 'react'
import { RichTextWrapper } from '../../../styles/global'

//* utils
import ImgUtil from '../../../utils/img.utils'
import { renderRichText } from '../../../utils/richTextHandler.utils'
import formatInlineCode from '../../../utils/shortTextFormatting'

//* components
import Typography from '../typography'
import WrapperImage from '../wrapperImage'

type Props = {
  mainImageSrc: string
  mainImageAlt: string
  heading: string
}

export const ImageContainer: FC<Props> = ({ mainImageSrc, mainImageAlt, heading }) => (
  <div className="Benefits__Image-Graphic-Outer">
    <div className="Benefits__Image-Container">
      {mainImageSrc && (
        <WrapperImage
          className="Benefits__Image"
          loading="lazy"
          alt={mainImageAlt}
          src={ImgUtil.getResizedImageUrl(mainImageSrc, 'width=282')}
          width={282}
          height={282}
          threshold={650}
        />
      )}
    </div>

    <Typography className="Benefits__Image-Typography" type="header2">
      {formatInlineCode(heading)}
    </Typography>
  </div>
)

export const Icons = ({ icons }: any) => (
  <Grid container className="Benefits__Inner-Container Benefits__Inner-Container-Icons" spacing={2}>
    {icons?.map((item: any, index: number) => {
      const colorIconUrl = item?.colorIcon?.file?.url || ''
      return (
        <Grid className="Benefits__Item-Container" key={index}>
          {colorIconUrl && (
            <WrapperImage
              src={ImgUtil.getResizedImageUrl(colorIconUrl, `width=64`)}
              alt="icon"
              width={64}
              height={64}
              threshold={650}
            />
          )}

          <div className="Benefits__Text-Container">
            {item.title && (
              <Typography className="Benefits__Benefit-Header" type="header5">
                {item.title}
              </Typography>
            )}

            {item.body && (
              <RichTextWrapper $type="body" className="Benefits__Benefit-Body">
                {renderRichText(item.body)}
              </RichTextWrapper>
            )}
          </div>
        </Grid>
      )
    })}
  </Grid>
)
